<template>
  <b-container fluid class="mb-6 mt-6 p-0">
    <b-row>
      <b-col>
        <div class="card card-custom gutter-b">
          <div class="mt-0">
            <template-table
              :column="column"
              :data="data"
              :paging="paging"
              :tableAction="false"
              :selectAction="false"
              :searchAction="false"
            >
              <template v-slot:body="{ item }">
                <td>
                  <span class="font-weight-bolder">
                    {{ $moment(item.date * 1000).format('HH:mm, DD/MM/YYYY') }},
                    {{ item.timeFrameText }}
                  </span>
                </td>
                <td>
                  <span class="font-weight-bolder">
                    <img
                      :src="item.emotionIcon && item.emotionIcon.url"
                      alt=""
                      class="mr-2 icon"
                    />
                    {{ item.emotionText }}
                  </span>
                </td>
                <td>
                  <span
                    class="font-weight-bolder ml-4"
                    v-for="(e, index) in item.symptoms"
                    :key="index"
                  >
                    <img :src="e.icon && e.icon.url" alt="" class="mr-2 icon" />
                    {{ e.text }}
                  </span>
                  <span v-if="item.otherSymptom"
                    >Triệu chứng khác: {{ item.otherSymptom }}</span
                  >
                </td>
                <td>
                  <span
                    class="font-weight-bolder ml-4"
                    v-for="(e, index) in item.activities"
                    :key="index"
                  >
                    <img :src="e.icon && e.icon.url" alt="" class="mr-2 icon" />
                    {{ e.text }}
                  </span>
                  <span v-if="item.otherActivity"
                    >Hoạt động khác: {{ item.otherActivity }}</span
                  >
                </td>
                <td>
                  <div class="d-flex">
                    <div
                      class="preview"
                      v-for="(image, index) in item.images"
                      :key="index"
                    >
                      <img
                        @click.stop="handlePreview(image.url)"
                        :src="image.url"
                        class="preview-image"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
              </template>
            </template-table>
          </div>
          <image-preview :image.sync="imagePreview" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { fetchAllPages } from '../exportExcel';
export default {
  name: 'FeelingTable',
  components: {
    'image-preview': () => import('../components/ModalPreview.vue'),
  },
  props: {
    time: {
      type: Object,
    },
    idUser: {
      type: [String, Number],
    },
  },
  data() {
    return {
      column: [
        {
          key: 'date',
          label: 'Ngày nhập',
          sortable: false,
        },
        {
          key: 'emotion',
          label: 'Cảm xúc',
          sortable: false,
        },
        {
          key: 'symptoms',
          label: 'Triệu chứng',
          sortable: false,
        },
        {
          key: 'activities',
          label: 'Hoạt động',
          sortable: false,
        },
        {
          key: 'thumbnail',
          label: 'Hình ảnh',
          sortable: false,
        },
      ],

      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        currentDateTime: parseInt(new Date().getTime() / 1000),
        periodFilterType: 1,
      },
      imagePreview: null,
      emotions: [],
      data: [],
    };
  },
  watch: {
    paging: {
      handler(newVal) {
        if (newVal) {
          this.loadData();
        }
      },
      deep: true,
    },
    time: {
      handler(newVal) {
        this.searchParams.periodFilterType = newVal.value;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    id() {
      return this.idUser;
    },
  },

  methods: {
    async exportRows() {
      const data = await fetchAllPages(this.$api, 'Admin/Emotion/Input', {
        ...this.searchParams,
        patientId: this.id,
      });
      const join = (list, other) =>
        [...(list || []).map((x) => x.text), other].filter(Boolean).join('; ');
      return {
        columns: ['Ngày nhập', 'Khung giờ', 'Cảm xúc', 'Triệu chứng', 'Hoạt động', 'Hình ảnh'],
        rows: (data || []).map((e) => [
          this.$moment(e.date * 1000).format('HH:mm DD/MM/YYYY'),
          e.timeFrameText,
          e.emotionText,
          join(e.symptoms, e.otherSymptom),
          join(e.activities, e.otherActivity),
          (e.images || []).map((i) => i.url).join('\n'),
        ]),
      };
    },
    handlePreview(image) {
      this.imagePreview = image;
      this.$bvModal.show('image-preview');
    },

    loadData() {
      this.$store.commit('context/setLoading', true);
      this.$api
        .get('Admin/Emotion/Input', {
          params: {
            ...this.searchParams,
            ...this.paging,
            size: this.paging.pageSize,
            patientId: this.id,
          },
        })
        .then(({ meta, data }) => {
          this.data = data || [];

          this.paging.total = meta.total;
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        })
        .finally(() => {
          this.$store.commit('context/setLoading', false);
        });
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 30px;
  height: 30px;
  object-fit: cover;
}
.preview {
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.preview:not(:first-child) {
  margin-left: 10px;
}
.preview-image {
  border-radius: 6px;
  display: block;
  width: 100%;
  object-fit: cover;
  height: 100%;
}
</style>
